import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    CmpsCardComponentModule,
    CmpsCardHeaderRowComponentModule,
    CmpsMetricPerformanceModule,
    CmpsUserProfileModule,
} from '@cmps/ng-kit';
import {
    CmpsButtonModule,
    CmpsDialogModule,
    CmpsIconModule,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';

import { CmpsCoachingInsightModule } from '../coaching-insight/coaching-insight.module';
import { CmpsCommonModule } from '../common/common.module';
import { CmpsSingleDecimalPointModule } from '../common/pipe/single-decimal-point';
import { CmpsLazyI18nModule } from '../i18n/i18n.module';
import { ChartModule } from '../scorecard-mi2/chart/chart.module';
import { CmpsMi2TrendDialogModule } from '../scorecard-mi2/trend-dialog';
import { WidgetConfiguration } from '../widget/config.widget.model';
import { CMPS_WIDGET_CONFIG } from '../widget/widget.metadata';
import { CmpsWidgetModule } from '../widget/widget.module';

import { MyCoachingCardComponent } from './my-coaching-card.component';
import { TranslationIdMap } from './my-coaching-card.i18n';
import { CmpsTrendViewDialogComponent } from './trend-view-dialog/trend-view-dialog.component';

@NgModule({
    imports: [
        CommonModule,
        CmpsCommonModule,
        CmpsCardComponentModule,
        CmpsCardHeaderRowComponentModule,
        CmpsDialogModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsMetricPerformanceModule,
        CmpsUserProfileModule,
        CmpsWidgetModule,
        CmpsCoachingInsightModule,
        CmpsIconModule,
        ChartModule,
        CmpsMi2TrendDialogModule,
        CmpsButtonModule,
        CmpsTooltipModule,
        CmpsSingleDecimalPointModule,
    ],
    declarations: [MyCoachingCardComponent, CmpsTrendViewDialogComponent],
    exports: [MyCoachingCardComponent, CmpsTrendViewDialogComponent],
    providers: [
        {
            provide: CMPS_WIDGET_CONFIG,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            useValue: {
                typeId: 25,
                definitionId: null,
                title: null,
                width: null,
                cssClassOverride: null,
                attributes: null,
            } as WidgetConfiguration,
        },
    ],
})
export class CmpsMyCoachingCardModule {}
